import type { ReactNode } from 'react';
import React from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { Text } from '@balance-web/text';
import { Box } from '@balance-web/box';
export type LabelProps = {
  children: ReactNode;
};

export const MenuTitle = ({ children }: LabelProps) => {
  return (
    <DropdownMenuPrimitive.Label>
      <Box paddingBottom="medium" paddingTop="small" paddingX="small">
        <Text size="xsmall" weight="medium">
          {children}
        </Text>
      </Box>
    </DropdownMenuPrimitive.Label>
  );
};
